<template>
	<div class="filters">
		<div class="service-status-container">
			<div class="label">{{ $t('components.service.select_status') }}</div>

			<div class="service-status">
				<div class="status" :class="{ 'selected' : inSelected(status) }" :key="index" v-for="(status, index) in serviceStatus" @click="selectStatus(status, index)">
					<span>
						{{ status.label }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { find, findIndex } from 'lodash'

	export default {
		name: 'ServiceFilters',

		data () {
			return {
				serviceStatus: [
					{
						name: 'active',
						label: this.$t('components.service.status.active')
					},
					{
						name: 'unset|deletable',
						label: this.$t('components.service.status.unset')
					},
					{
						name: 'inactive',
						label: this.$t('components.service.status.inactive')
					},
          {
            name: 'overdue',
            label: this.$t('components.service.status.overdue')
          },
				],
				selectedStatus: [
          {
            name: 'overdue',
            label: this.$t('components.service.status.overdue')
          },
					{
						name: 'active',
						label: this.$t('components.service.status.active')
					},
					{
						name: 'unset|deletable',
						label: this.$t('components.service.status.unset')
					}
				]
			}
		},

		methods: {
			selectStatus (status, index) {
				if (!this.inSelected(status)) {
					this.selectedStatus.push(status)
				} else {
					this.selectedStatus.splice(findIndex(this.selectedStatus, status), 1)
				}
				this.$emit('changed', this.parsedStatus)
			},

			inSelected (status) {
				return !!find(this.selectedStatus, status)
			}
		},

		computed: {
			parsedStatus () {
				let returnStatus = ''

				this.selectedStatus.map((currentValue, index) => {
					returnStatus += currentValue.name + '|'
				})

				return returnStatus
			}
		}
	}
</script>

<style lang="scss">
	.filters {
		display: flex;
		align-items: flex-end;
		justify-content: flex-end;
		width: 100%;
		margin: 0.5rem 0;
		flex-flow: column;

		.service-status-container {
			background: #fff;
			padding: 1rem;
			border-radius: 15px;

			.label {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				font-size: 1.2em;
				font-weight: 700;
				width: 100%;
				margin: 0;
				padding-bottom: 1rem;
			}

			.service-status {
				display: flex;
				align-items: center;
				justify-content: center;
				flex-flow: row;

				.status {
					flex-grow: 1;
					display: flex;
					align-items: center;
					border-radius: 10em;
					padding: .6rem 1.3rem;
					position: relative;
					overflow: hidden;
					background: #fff;
					margin: 0 .1rem;
					font-weight: 700;
					color: #03A9F4;
					-webkit-transition: all 0.2s;
					-moz-transition: all 0.2s;
					-ms-transition: all 0.2s;
					-o-transition: all 0.2s;
					transition: all 0.2s;

					&:last-child {
						margin: 0 0 0 .1rem;
					}

					&:after {
						content: "";
						opacity: 0;
						position: absolute;
						top: 0; right: 0; left: 0; bottom: 0;
						width: 100%;
						height: 100%;
						z-index: 0;
						background: linear-gradient(45deg, #00a9f7, #0078f7);

						-webkit-transition: all 0.2s;
						-moz-transition: all 0.2s;
						-ms-transition: all 0.2s;
						-o-transition: all 0.2s;
						transition: all 0.2s;
					}

					&.selected {
						color: #fff;

						&:after {
							opacity: 1;
						}
					}

					&:hover {
						cursor: pointer;
						background: #d3d3d3;
					}

					span {
						z-index: 1;
					}
				}
			}
		}
	}

  @media only screen and (max-width: 350px) {
    .filters {
      .service-status-container {
        width: 100%;

        .service-status {
          .status {
            font-size: .85rem;
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/subscription/ServiceFilters.vue